export default __webpack_public_path__ + "static/media/filter.b9a821a9.svg";